import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CRM_BASE_URL } from "../../app/crmApi";

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);
    const scroll = useRef(null);

    useEffect(() => {
        let active = true;
        axios
            .get(`${CRM_BASE_URL}policies/user/privacy_policy`)
            .then((res) => {
                if (active && res.data?.success) setPolicy(res.data.data);
            })
            .catch(() => {
                if (active) setPolicy(null);
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        scroll.current?.scrollIntoView({ behavior: "smooth" });
        return () => {
            active = false;
        };
    }, []);

    return (
        <section className="faq" ref={scroll}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tc">
                            <div className="tc-wrapper">
                                <div className="title">
                                    <h4 className="blue-b-32">
                                        {loading
                                            ? "Loading..."
                                            : policy?.title || "Privacy Policy"}
                                    </h4>
                                </div>

                                <div
                                    className="tc-text"
                                    dangerouslySetInnerHTML={{
                                        __html: policy?.content || "",
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;
